var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 125,
    viewBox: "0 0 92 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8836_20241)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.576904,
    width: 182.288,
    height: 124.724,
    fill: "#E9ECEF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2904 38.3789C14.7018 38.3789 10.1714 42.9094 10.1714 48.4979C10.1714 54.0709 14.6764 58.5916 20.2434 58.6169L21.9334 61.8696C22.2755 62.5281 23.2176 62.5281 23.5597 61.8696L25.2497 58.617H51.2211C56.8096 58.617 61.3401 54.0865 61.3401 48.4979C61.3401 42.9094 56.8096 38.3789 51.221 38.3789H20.2904Z",
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.4456,
    y: 47.0518,
    width: 29.487,
    height: 1.92744,
    rx: 0.963718,
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.4456,
    y: 43.1963,
    width: 29.487,
    height: 1.92744,
    rx: 0.963718,
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.4456,
    y: 50.9053,
    width: 13.8763,
    height: 1.92744,
    rx: 0.963718,
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2792 91.1436C14.6966 91.1436 10.1709 95.6692 10.1709 101.252C10.1709 106.823 14.6772 111.341 20.2434 111.36L21.9335 114.61C22.2758 115.268 23.2172 115.268 23.5595 114.61L25.2496 111.36H51.2313C56.8139 111.36 61.3396 106.835 61.3396 101.252C61.3396 95.6692 56.8139 91.1436 51.2313 91.1436H20.2792Z",
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.4451,
    y: 99.8076,
    width: 29.487,
    height: 1.9254,
    rx: 0.962699,
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.4451,
    y: 95.957,
    width: 29.487,
    height: 1.9254,
    rx: 0.962699,
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.4451,
    y: 103.659,
    width: 13.8763,
    height: 1.9254,
    rx: 0.962699,
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1026 65.5615C35.5002 65.5615 30.9585 70.1032 30.9585 75.7056C30.9585 81.308 35.5002 85.8497 41.1026 85.8497H68.6443L70.29 89.0249C70.6318 89.6845 71.5753 89.6845 71.9172 89.0249L73.6319 85.7163C78.4502 84.9288 82.1272 80.7466 82.1272 75.7056C82.1272 70.1032 77.5855 65.5615 71.9831 65.5615H41.1026Z",
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.2327,
    y: 74.2539,
    width: 29.487,
    height: 1.9322,
    rx: 0.966102,
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.2327,
    y: 70.3896,
    width: 29.487,
    height: 1.9322,
    rx: 0.966102,
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.2327,
    y: 78.1201,
    width: 13.8763,
    height: 1.9322,
    rx: 0.966102,
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.3324 19.1875C57.3561 19.1875 54.9434 21.6003 54.9434 24.5765C54.9434 27.5528 57.3561 29.9656 60.3324 29.9656H74.9634L75.8383 31.6537C76.0199 32.0041 76.5212 32.0041 76.7028 31.6537L77.6145 29.8946C80.1738 29.4759 82.1267 27.2543 82.1267 24.5765C82.1267 21.6003 79.714 19.1875 76.7377 19.1875H60.3324Z",
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.9331,
    y: 23.8081,
    width: 15.665,
    height: 1.02648,
    rx: 0.513242,
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.9329,
    y: 21.7529,
    width: 15.665,
    height: 1.02648,
    rx: 0.513242,
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.9329,
    y: 25.8604,
    width: 7.37176,
    height: 1.02648,
    rx: 0.513242,
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7661 56.5857V61.4087C39.7661 61.4087 42.1165 61.7329 44.5608 61.6534C45.083 61.6364 45.5667 61.3475 45.7493 60.8579C46.2142 59.6108 46.2784 58.0711 46.2578 57.0598C46.2453 56.4455 45.732 55.9828 45.1183 56.0121C43.3837 56.0948 41.0752 56.3402 39.7661 56.5857Z",
    fill: "#F8FAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5908 53.6783C42.3952 53.6266 42.1924 53.5991 42.0199 53.5848C41.7559 53.5629 41.5287 53.7452 41.4577 54.0004C41.2799 54.6391 40.9249 55.8634 40.5698 56.7865H43.1823C43.1823 56.7865 43.3187 55.6952 43.2544 54.6365C43.2281 54.2038 43.0098 53.7892 42.5908 53.6783Z",
    fill: "#F8FAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1871 61.2679C38.1925 61.4802 38.3122 61.6729 38.5172 61.7281C38.6792 61.7716 38.8981 61.8105 39.1632 61.8105C39.4284 61.8105 39.6473 61.7716 39.8093 61.7281C40.0143 61.6729 40.134 61.4802 40.1394 61.2679C40.1507 60.8196 40.1681 59.9741 40.1681 58.997C40.1681 58.02 40.1507 57.1744 40.1394 56.7262C40.134 56.5139 40.0143 56.3211 39.8093 56.266C39.6473 56.2225 39.4284 56.1836 39.1632 56.1836C38.8981 56.1836 38.6792 56.2225 38.5172 56.266C38.3122 56.3211 38.1925 56.5139 38.1871 56.7262C38.1758 57.1744 38.1584 58.02 38.1584 58.997C38.1584 59.9741 38.1758 60.8196 38.1871 61.2679Z",
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.1711,
    y: 9.59473,
    width: 33.5795,
    height: 6.39609,
    rx: 3.19804,
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.1711,
    y: 17.5898,
    width: 19.1883,
    height: 1.59902,
    rx: 0.799511,
    fill: "#ADB5BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8836_20241"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.576904,
    width: 91.1442,
    height: 124.724,
    rx: 4.79707,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.785249af3a0f0daafd2c2f771858dfd2.svg";
export { ForwardRef as ReactComponent };